import type { SettingsTranslation } from "./index";

export const italian = {
  section_appearance: "Aspetto e lingua",
  section_notifications: "Notifiche",
  section_privacy: "Privacy",
  section_security: "Sicurezza",
  saving: "Salvataggio...",
  saved: "Salvato",
  auto_analyze_recordings: "Analizza automaticamente le sessioni",
  auto_analyze_recordings_help:
    "Analizza ogni sessione appena viene caricata, cioè subito dopo la tua approvazione se Revisione prima del caricamento è attiva. Se disattivato, le sessioni restano Non analizzate finché non avvii l'analisi.",
  recording_screenshot_format: "Compressione",
  recording_screenshot_format_help:
    "Comprimere gli screenshot riduce il traffico di rete e velocizza la sincronizzazione, ma usa la CPU durante la registrazione. Disattivala per ottimizzare le prestazioni.",
  screenshot_format_load_failed: "Impossibile caricare l'impostazione di compressione",
  screenshot_format_update_failed: "Impossibile aggiornare l'impostazione di compressione",
  recording_screenshot_blacklist: "App escluse",
  recording_screenshot_blacklist_help:
    "Finché una di queste app è in primo piano, non viene registrato nulla.",
  screenshot_blacklist_load_failed: "Impossibile caricare le app escluse",
  screenshot_blacklist_update_failed: "Impossibile aggiornare le app escluse",
  screenshot_blacklist_app_placeholder: "Nome dell'app",
  screenshot_blacklist_add: "Aggiungi",
  screenshot_blacklist_empty: "Nessuna app esclusa.",
  screenshot_blacklist_remove: "Rimuovi {{app}}",
  recording_screenshot_redaction: "Oscuramento del testo sensibile",
  recording_screenshot_redaction_help:
    "I testi sensibili rilevati negli screenshot (email, numeri di carta, credenziali…) vengono oscurati prima del salvataggio. Il rilevamento non è garantito; si applica dal prossimo avvio della registrazione.",
  screenshot_redaction_load_failed:
    "Impossibile caricare l'impostazione di oscuramento del testo sensibile",
  redaction_categories: "Cosa viene oscurato",
  redaction_category_enabled: "Attiva",
  redaction_category_experimental: "Includi sperimentali",
  redaction_experimental_help:
    "I rilevamenti sperimentali individuano più testo sensibile, ma sono meno precisi e possono oscurare anche contenuti innocui.",
  redaction_category_credentials: "Credenziali e segreti",
  redaction_category_accounts: "Carte e conti bancari",
  redaction_category_financial: "Importi finanziari",
  redaction_category_personal: "Identità personale",
  redaction_category_contact: "Recapiti",
  redaction_category_network: "Indirizzi di rete",
  redaction_category_organizations: "Organizzazioni",
  redaction_category_suspicious: "Testo dall'aspetto sospetto",
  redaction_category_help: {
    credentials:
      "Password, chiavi API, token di accesso e altri segreti che danno accesso ad account e sistemi.",
    accounts: "Numeri di carte di credito, IBAN e altri dati di pagamento e conti bancari.",
    financial: "Stipendi, retribuzioni e altri importi finanziari.",
    personal: "Numeri di documenti d'identità, codici fiscali, date di nascita e nomi di persona.",
    contact: "Indirizzi email, numeri di telefono e indirizzi postali.",
    network: "Indirizzi IP e altri identificatori di rete.",
    organizations: "Nomi di società e altre organizzazioni.",
    suspicious:
      "Testo che non rientra in una categoria precisa ma sembra comunque sensibile, come lunghe sequenze di cifre.",
  },
  notification_frequency: "Frequenza email",
  notification_frequency_help:
    "Ogni quanto possono essere inviate le email degli alert. I risultati trattenuti finiscono nell'email successiva.",
  notification_frequency_immediately: "Subito",
  notification_frequency_daily: "Al massimo ogni giorno",
  notification_frequency_weekly: "Al massimo ogni settimana",
  notification_frequency_monthly: "Al massimo ogni mese",
  notification_channel: "Recapito degli alert",
  notification_channel_help:
    "Dove ricevi i risultati degli alert. In-app arriva subito; le email seguono la frequenza qui sotto.",
  notification_channel_help_saas:
    "Dove ricevi i risultati degli alert. L'in-app richiede l'app desktop — nel browser i risultati compaiono solo nella watchlist. Le email seguono la frequenza qui sotto.",
  notification_channel_in_app_warning:
    "Le notifiche in-app arrivano solo mentre l'app è aperta. Senza email, i risultati arrivati in tua assenza restano silenziosi nella watchlist.",
  notification_channel_in_app_saas_warning:
    "Le notifiche in-app richiedono l'app desktop, non il browser. Aggiungi l'email per essere avvisato qui.",
  notification_settings_load_failed: "Impossibile caricare le impostazioni di notifica",
  notification_settings_update_failed: "Impossibile aggiornare le impostazioni di notifica",
  change_password: "Cambia password",
  change_password_help:
    "Usa la password attuale per scegliere una nuova password per questo account.",
  current_password: "Password attuale",
  new_password: "Nuova password",
  change_password_saved: "Password aggiornata.",
  change_password_failed: "Impossibile cambiare la password",
  mfa: "Autenticazione a due fattori",
  mfa_enabled: "Attiva",
  mfa_disabled: "Disattiva",
  mfa_enabled_help: "Il login con password richiede un codice dell'app di autenticazione.",
  mfa_disabled_help:
    "Aggiungi un secondo passaggio al login con password usando un'app di autenticazione.",
  mfa_enable: "Attiva 2FA",
  mfa_disable: "Disattiva 2FA",
  mfa_enroll_help:
    "Aggiungi questo segreto alla tua app di autenticazione, poi inserisci il codice a 6 cifre generato.",
  mfa_disable_help:
    "Inserisci un codice attuale dell'app di autenticazione per disattivare l'autenticazione a due fattori.",
  mfa_code: "Codice autenticatore",
  mfa_qr_code: "Scansiona questo codice QR con la tua app di autenticazione",
  mfa_confirm: "Conferma codice",
  mfa_copy_secret: "Copia segreto",
  mfa_open_authenticator: "Apri nell'app di autenticazione",
  mfa_load_failed: "Impossibile caricare lo stato della 2FA",
  mfa_start_failed: "Impossibile avviare l'attivazione della 2FA",
  mfa_confirm_failed: "Impossibile attivare l'autenticazione a due fattori",
  mfa_disable_failed: "Impossibile disattivare l'autenticazione a due fattori",
  theme: "Tema",
  theme_light: "Chiaro",
  theme_dark: "Scuro",
  toggle_on: "Attivo",
  toggle_off: "Disattivo",
  recording_review_before_upload: "Revisione prima del caricamento",
  recording_review_before_upload_help:
    "Tieni ogni sessione completata su questo computer finché non la approvi o la elimini. Se disattivato, le sessioni vengono caricate appena terminano.",
  recording_review_load_failed:
    "Impossibile leggere l'impostazione di revisione prima del caricamento",
  pending_review_title: "Sessioni in attesa della tua revisione",
  pending_review_message:
    "{{count}} sessioni sono ancora in attesa della tua revisione. Caricarle ora o tenerle da rivedere?",
  pending_review_message_one:
    "{{count}} sessione è ancora in attesa della tua revisione. Caricarla ora o tenerla da rivedere?",
  pending_review_upload: "Carica ora",
  pending_review_keep: "Tieni da rivedere",
  pending_review_upload_failed: "Caricamento delle sessioni in attesa di revisione non riuscito",
} satisfies SettingsTranslation;
